import {
  ROLE_CARRIER,
  ROLE_CIF_DRIVER,
  ROLE_FOB_DRIVER,
} from "@components/Routes/TypesPermissions";
import { UserType } from "@utils/enum";
import {
  legacyCheckOnlyDriverPermission,
  legacyCheckCarrierPermission,
  legacyCheckCIFDriverPermission,
  legacyCheckDriverOrContactPermission,
  legacyGetUserType,
} from "@utils/permissions/legacyPermissionChecks";

/**
 * Métodos V2 são os métodos que utilizam os novos system_modules após a refatoração de permissões
 * métodos legacy utilizam os system_modules antigos, permitem compatibilidade com usuários antigos,
 * eventualmente devem ser descontinuados, desde que as permissões dos usuários antigos seja corretamente
 * atualizada...
 */

// Motorista operacional: roles "fob_driver" sem role "carrier" e "cif_driver"
// Referencias: https://atemdevs.atlassian.net/wiki/spaces/PDCA/pages/27688972/Vis+o+do+Perfil+Motorista
function checkOnlyDriverPermissionV2(
  _systemModules: string[],
  roles: string[]
): boolean {
  const hasDriverRole = roles.includes(ROLE_FOB_DRIVER);
  const hasCarrierRole = roles.includes(ROLE_CARRIER);
  const hasCIFDriverRole = roles.includes(ROLE_CIF_DRIVER);
  return !hasCarrierRole && (hasCIFDriverRole || hasDriverRole);
}

export function checkOnlyDriverPermission(
  systemModules: string[],
  roles: string[],
  useSystemModulesAuth: boolean
): boolean {
  if (useSystemModulesAuth) {
    return checkOnlyDriverPermissionV2(systemModules, roles);
  }
  return legacyCheckOnlyDriverPermission(systemModules, roles);
}

function checkCarrierPermissionV2(
  _systemModules: string[],
  roles: string[]
): boolean {
  return roles.includes(ROLE_CARRIER);
}

export function checkCarrierPermission(
  systemModules: string[],
  roles: string[],
  useSystemModulesAuth: boolean
): boolean {
  if (useSystemModulesAuth) {
    return checkCarrierPermissionV2(systemModules, roles);
  }
  return legacyCheckCarrierPermission(systemModules, roles);
}

function checkCIFDriverPermissionV2(roles: string[]): boolean {
  return roles.includes(ROLE_CIF_DRIVER);
}

export function checkCIFDriverPermission(
  roles: string[],
  useSystemModulesAuth: boolean
): boolean {
  if (useSystemModulesAuth) {
    return checkCIFDriverPermissionV2(roles);
  }
  return legacyCheckCIFDriverPermission(roles);
}

export function checkDriverOrContactPermission(
  systemModules: string[],
  roles: string[]
): boolean {
  return legacyCheckDriverOrContactPermission(systemModules, roles);
}

function getUserTypeV2(_systemModules: string[], roles: string[]): UserType {
  if (roles.includes(ROLE_CARRIER)) return UserType.Transportadora;
  if (roles.includes(ROLE_CIF_DRIVER)) return UserType.Motorista;
  if (roles.includes(ROLE_FOB_DRIVER)) return UserType.Motorista;
  return UserType.Cliente;
}

export const getUserType = (
  systemModules: string[],
  roles: string[],
  useSystemModulesAuth: boolean
): UserType => {
  if (useSystemModulesAuth) {
    return getUserTypeV2(systemModules, roles);
  }
  return legacyGetUserType(systemModules, roles);
};
